import { StylesProvider, TraitsProvider } from "@grapesjs/react";
import { Box } from "@mantine/core";

import { CustomStyleManager } from "./style-manager/CustomStyleManager";
import { CustomTraitManager } from "./trait-manager/CustomTraitManager";

export const BuilderRightSidebar = () => {
  return (
    <Box
      sx={{
        flexShrink: 0,
        width: 340,
        background: "var(--var-builder-panel-color)",
        borderLeft: "1px solid var(--mantine-color-gray-3)",
        maxHeight: "100%",
        overflow: "auto",
      }}
    >
      <TraitsProvider>
        {(props) => <CustomTraitManager {...props} />}
      </TraitsProvider>

      <StylesProvider>
        {(props) => <CustomStyleManager {...props} />}
      </StylesProvider>
    </Box>
  );
};
